export default {
  featuredExperiences: 'Onze uitgelichte ervaringen',
  searchAllExperiences: 'Alle ervaringen zoeken',
  searchAll: 'Alles zoeken',
  groupSize: 'Groepsgrootte',
  eventSize: 'Evenementgrootte',
  upTo: 'Tot',
  whatWeDo: 'Wat we gaan doen',
  hostedBy: 'Gehost door',
  whatsIncluded: 'Wat is inbegrepen',
  avail: 'Beschikbaarheid',
  whereWeAre: 'Waar we zullen zijn',
  experienceCalendar: 'Ervaringskalender',
  experienceCancelled: 'Ervaring geannuleerd',
  experienceStartingPrice: 'Vanaf {{price}}',
  experienceTotalPrice: 'Totaal {{price}}',
  at: 'om',
  viewPrivateSessAvailability: 'Beschikbaarheid privésessie bekijken',
  selectDuration: 'Duur',
  selectStartTime: 'Starttijd',
  selectSession: 'Selecteer sessie',
  sessionsCount: '{{count}} tijden — kies een tijd',
  noAvailability: 'Geen beschikbaarheid',
  select: 'Selecteer',
  slotLeft: '{{remainSlots}} plaats over',
  slotsLeft: '{{remainSlots}} plaatsen over',
  spotsLeft: '{{count}} over',
  spotsLeftAriaLabel: '{{count}} plekken over',
  bookExperience: 'Ervaring boeken',
  book: 'Boeken',
  learnMore: 'Meer informatie',
  apply: 'Toepassen',
  maxPartySizes: 'Maximaal {{maxGroupSize}} plaatsen per groep',
  maxPartySize: 'Maximaal {{maxGroupSize}} plaats per groep',
  selectSessionValidation: 'Selecteer een sessie',
  selectParticipantValidation: 'Selecteer deelnemers',
  selectDateValidation: 'Selecteer een datum',
  reminders: 'Herinneringen',
  seeOtherDates: 'Andere datums bekijken',
  location: 'Locatie',
  about: 'Over',
  allExperiences: 'Alle ervaringen',
  soldOut: 'Uitverkocht',
  addOns: "Extra's",
  reviews: 'Beoordelingen',
  reviewSingular: 'beoordeling',
  reviewPlural: 'beoordelingen',
  dateOfExperience: 'Datum van de ervaring',
  readLess: 'Minder lezen',
  readMore: 'Meer lezen',
  seeMore: 'Meer bekijken',
  details: 'Details',
  durationHour: 'uur',
  durationHours: 'uur',
  durationMinutes: 'min',
  theFollowingVideoDoesNotContainAnyAudio: 'De volgende video bevat geen audio',
  by: 'Door',
  chooseATime: 'Kies een tijd voor {{title}}',
  amenities: 'Voorzieningen',
  ticketSalesOpenIn: 'Ticketverkoop opent over',
  ticketSalesOpen: 'Ticketverkoop is geopend',
  ticketSalesCloseIn: 'Ticketverkoop sluit over',
  ticketSalesClose: 'Ticketverkoop sluit',
  ticketSalesClosed: 'Ticketverkoop gesloten',
  comingSoon: 'Binnenkort beschikbaar',
  inPartnershipWith: 'In samenwerking met',
  notFoundExperienceTitle: 'Deze ervaring is niet meer beschikbaar',
  notFoundExperienceSubtitle:
    'Het kan zijn dat deze is verwijderd of dat de link niet meer geldig is.',
  deadLinkRecoverySubtitle: 'Ontdek andere ervaringen die je kunt boeken',
  viewAllExperiences: 'Alle ervaringen bekijken',
  experienceBenefits: {
    benefits: {
      basePointsEarn:
        '<p><strong>Verdien 5 basispunten</strong> per in aanmerking komende $1 USD besteed wanneer u inlogt op uw World of Hyatt-account om deze ervaring te boeken</p>',
      basePoints:
        '<p><strong>Verdien 10 basispunten</strong> per in aanmerking komende $1 USD besteed wanneer u inlogt op uw World of Hyatt-account om deze ervaring te boeken</p>',
      additionalBonusPoints:
        '<p><strong>Verdien 4 extra bonuspunten</strong> per in aanmerking komende $1 USD besteed wanneer u boekt met uw World of Hyatt-creditcard</p>',
      additionalBonusPointsTier:
        '<p><strong>Verdien tot 30% extra bonuspunten</strong> afhankelijk van uw lidmaatschapsniveau</p>',
      payWithPoints:
        '<p><strong>Betaal met punten</strong> bij het boeken van deze ervaring</p>',
    },
  },
};
